// Hooks
import apiGetWidget from "@/hooks/requests/apiGetWidget/apiGetWidget";
import useBrands from "@/hooks/useBrands/useBrands";
import useHelpCrunchChat from "@/hooks/useHelpCrunchChat";
import { useAnalyticsStore } from "@/stores/analytics/analytics";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";

// Data
import TRANSLATIONS from "../translation/translations.js";

export default async function initWidget(): Promise<void> {
    const TIWStore = useTIWStore();
    const AnalyticsStore = useAnalyticsStore();

    const widgetData = await apiGetWidget({
        domain: TIWStore.INJECTED_TIW.current_settings.domain,
    });

    widgetData.data.translations = TRANSLATIONS;

    AnalyticsStore.MEASUREMENT_ID =
        widgetData.data.data.measurement_id ?? AnalyticsStore.MEASUREMENT_ID;
    AnalyticsStore.API_SECRET = widgetData.data.data.api_secret ?? AnalyticsStore.API_SECRET;
    AnalyticsStore.initClientId();
    AnalyticsStore.initSessionId();

    TIWStore.WIDGET_DATA = widgetData.data;

    if (TIWStore.showHelpCrunchChat) {
        useHelpCrunchChat();
    }

    if (TIWStore.customStyles.font.google) {
        const link = document.createElement("link");
        link.href = TIWStore.customStyles.font.google;
        link.rel = "stylesheet";
        document.head.appendChild(link);
    } else if (TIWStore.customStyles.font.link) {
        const style = document.createElement("style");
        style.innerHTML = `
            @font-face {
                font-family: "${TIWStore.customStyles.font.family}";
                src: url("${TIWStore.customStyles.font.link}");
            }
        `;
        document.body.prepend(style);
    }

    await useBrands();
}
